import { ServiceDataResource } from '@/modules/ta/service/resources/ServiceDataResource';
import { RouteGroup } from '@/modules/core/app/constants/api.constants';
import { workerAxios } from '@/modules/core/app/helpers/WorkerManagerHelper';
import { STATUS_FAILURE } from '@/modules/ta/widget/widget.constants';

export class ServiceDataLiveDataResource extends ServiceDataResource {
  constructor() {
    super(RouteGroup.SERVICES);
    this.apiHelper = workerAxios;
  }

  /**
   * @param result
   * @param model
   * @param params
   * @returns {*}
   */
  extractData(result, model, params) {
    if (result.status === STATUS_FAILURE) {
      return result;
    }

    return super.extractData(result, model, params);
  }
}

export default new ServiceDataLiveDataResource();
